module.exports = __webpack_public_path__ + "static/media/emailhover.1c30a47d.svg";